<template>
  <div id="section-action">
    <div class="row">
      <div class="col">
        <detail 
          :item="item"
          :attackBonus="attackBonus"
          :damageBonus="damageBonus"
          :ruleset="ruleset"
          @setId="$emit('setId')">
        </detail>
      </div>
    </div>

  </div>
</template>
<script>
import Detail from "./_Detail.vue";

export default {
  name: "sheet-actions-action",
  components: {
    Detail
  },
  props: ["item", "attackBonus", "damageBonus", "ruleset"]
};
</script>
